import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Customers_Profile_ContactPreferencesModel,
  ResponseModels_Customers_Profile_ContactPreferencesModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetContactPreferencesV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
};
/**
 * Gets the preferences contact
 *
 * @returns ResponseModels_Customers_Profile_ContactPreferencesModel Success
 */
export function getContactPreferencesV2(
  { businessUnit, label, customerId, accountId }: GetContactPreferencesV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Customers_Profile_ContactPreferencesModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/v2/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/contact-preferences`,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type UpdateContactPreferencesV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  requestBody?: RequestModels_Customers_Profile_ContactPreferencesModel;
};
/**
 * Update Contact Preferences (NL)
 *
 * @returns any Success
 */
export function updateContactPreferencesV2(
  { businessUnit, label, customerId, accountId, requestBody }: UpdateContactPreferencesV2,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/v2/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/contact-preferences`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
